module.exports = __webpack_public_path__ + "static/media/Team 31 - Easy Traffic.fd99c5a4.png";